/**
 * YouTube IFrame Player API 動態非同步載入器
 * 確保全站僅在真正需要播放或滾動到影片區塊時，才動態載入外部腳本，提升首屏載入速度與 SEO。
 */

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}

let ytApiPromise: Promise<any> | null = null;

export function loadYouTubeIframeApi(): Promise<any> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Window is not defined"));
  }

  // 若已經初始化過 YT 物件，直接回傳
  if (window.YT && window.YT.Player) {
    return Promise.resolve(window.YT);
  }

  // 若正在載入中，回傳同一個 Promise
  if (ytApiPromise) {
    return ytApiPromise;
  }

  ytApiPromise = new Promise((resolve, reject) => {
    try {
      // 檢查 DOM 是否已有 script 標籤
      let scriptTag = document.getElementById(
        "youtube-iframe-js-api-script"
      ) as HTMLScriptElement;

      if (!scriptTag) {
        scriptTag = document.createElement("script");
        scriptTag.id = "youtube-iframe-js-api-script";
        scriptTag.src = "https://www.youtube.com/iframe_api";
        scriptTag.async = true;
        const firstScriptTag = document.getElementsByTagName("script")[0];
        if (firstScriptTag && firstScriptTag.parentNode) {
          firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        } else {
          document.head.appendChild(scriptTag);
        }
      }

      // 保留可能已存在的 callback
      const previousReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof previousReady === "function") {
          previousReady();
        }
        if (window.YT && window.YT.ready) {
          window.YT.ready(() => resolve(window.YT));
        } else {
          resolve(window.YT);
        }
      };

      // 容錯機制：若 window.YT 提早準備好
      if (window.YT && window.YT.ready) {
        window.YT.ready(() => resolve(window.YT));
      }
    } catch (err) {
      ytApiPromise = null;
      reject(err);
    }
  });

  return ytApiPromise;
}
